<script lang="ts">
  import Form from "../components/Form.svelte";
  import SharepointFileInput from "../components/SharepointFileInput.svelte";
  import RadioGroup from "../components/RadioGroup.svelte";
  import { domId } from "../lib/dom";
  import type { Snippet } from 'svelte';

  let {
    action,
    taskTitle,
    taskQuestion,
    documentName,
    createUploadSessionUrl,
    uploadAttachmentExtensions,
    errors,
    children,
  }: {
    action: string;
    taskTitle: string;
    taskQuestion: string | Snippet;
    documentName: string;
    createUploadSessionUrl: string;
    uploadAttachmentExtensions: string[];
    errors: { [key: string]: string } | null;
    children?: Snippet;
  } = $props();

  let selectedOption = $state("yes");

  const closeDialogId = domId("close-dialog");
</script>

<Form method="patch" {action} class="ui-rhythm">
  <h2 class="ui-title">{taskTitle}</h2>

  <fieldset class="ui-fieldset">
    <legend>
      {#if typeof taskQuestion === "function"}{@render taskQuestion()}{:else}{taskQuestion}{/if}
    </legend>
    <RadioGroup
      name="has_document"
      options={[
        ["Yes", "yes"],
        ["No", "no"],
      ]}
      bind:group={selectedOption}
      required={true}
    />
  </fieldset>

  <fieldset class="ui-fieldset" class:invisible={selectedOption !== "yes"}>
    <SharepointFileInput
      name={documentName}
      accept={uploadAttachmentExtensions}
      {createUploadSessionUrl}
      required={selectedOption === "yes"}
      multiple={true}
    />
    {#if errors?.document_missing}
      <div class="ui-error">{errors.document_missing}</div>
    {/if}
    {#if children}
      <div>{@render children()}</div>
    {/if}
  </fieldset>

  {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

  <div class="floating-footer">
    <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
    <button class="btn btn-primary" type="submit" data-viewer-mode>Send</button>
  </div>
</Form>

<form method="dialog" id={closeDialogId}></form>
